import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import * as AppActions from '../../../AppActions';
import Carousel, {SWIPE_STATE} from '../../../Components/Carousel';

function HeroBannerSection(props) {
  const {landing} = props;
  const [dimension] = useOutlet('dimension');
  const mobile = dimension.rwd === 'mobile';

  const images = landing.custom_layout
    ? mobile
      ? landing.custom_layout.hero_banner_section.images_mobile
      : landing.custom_layout.hero_banner_section.images
    : [];
  const data =
    images.length > 0 ? images : [{image: '/images/landing-hero-banner.jpg'}];

  return (
    <Wrapper>
      <div className="container">
        {mobile ? (
          //size 1:1
          <Carousel
            width={dimension.innerWidth}
            height={dimension.innerWidth}
            data={data}
            renderPrev={null}
            renderNext={null}
            disableSwipe={true}
            renderItem={({item, dimension, swipeStateRef}) => (
              <SlideItem
                item={item}
                dimension={dimension}
                swipeStateRef={swipeStateRef}
              />
            )}
            renderDots={null}
          />
        ) : (
          // size 16:9
          <Carousel
            width={dimension.innerWidth}
            height={(dimension.innerWidth / 16) * 9}
            data={data}
            renderPrev={null}
            renderNext={null}
            disableSwipe={true}
            renderItem={({item, dimension, swipeStateRef}) => (
              <SlideItem
                item={item}
                dimension={dimension}
                swipeStateRef={swipeStateRef}
              />
            )}
            renderDots={null}
          />
        )}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  & > .container {
    overflow: hidden;
  }
`;

function SlideItem(props) {
  const {item, dimension, swipeStateRef} = props;
  const {width, height} = dimension;
  return (
    <SlideWrapper
      width={width}
      height={height}
      href={item.path}
      draggable={false}
      rel="noreferrer"
      target="_blank">
      <img
        src={item.image}
        draggable={false}
        onClick={(e) => {
          if (swipeStateRef.current === SWIPE_STATE.swipe) {
            e.preventDefault();
            return;
          }

          if (!item.path) {
            e.preventDefault();
            return;
          }

          if (item.path[0] === '/') {
            e.preventDefault();
            AppActions.navigate(item.path);
          }
        }}
      />
      <div className="logo-container">
        <img alt="logo" src="/images/site-logo-white.png" />
        <h3>發現更多創作者的商品</h3>
        <button
          onClick={(e) => {
            e.preventDefault();
            const element = document.querySelector('#creator-section');
            const rec = element.getBoundingClientRect();
            window.scrollTo({top: rec.top - 100, behavior: 'smooth'});
          }}>
          <img alt="icon" src="/images/landing-arrow-icon.png" />
        </button>
      </div>
    </SlideWrapper>
  );
}

const SlideWrapper = styled.a`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  position: relative;
  display: block;

  & > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    overflow: hidden;
    user-select: none;
    z-index: 1;
  }

  & > div {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 15px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & > img {
      margin-bottom: 30px;
      max-width: 450px;
      width: 100%;
    }

    & > h3 {
      margin-bottom: 60px;
      text-align: center;
      font-weight: 300;
      letter-spacing: 1.5px;
      color: #ffffff;
    }

    & > button {
      border: none;
      background-color: transparent;
      cursor: pointer;
      width: 45px;
      height: 45px;
      border-radius: 50%;

      & > img {
        width: 45px;
        height: 45px;
      }
    }
  }
`;

export default HeroBannerSection;
